import {
    DOMO_REPORT_FAILURE,
    DOMO_REPORT_LOAD,
    DOMO_REPORT_SUCCESS
} from './domoReportActions';
import { createSelector } from 'reselect';
import { get, isEqual } from 'lodash';
import { getEntityByName } from '../appEntities';

const initialState = {
    loading: false
};

export default function reducer(state = initialState, action = {}) {
    let newState;
    switch (action.type) {

        case DOMO_REPORT_LOAD:
            newState = {
                ...state,
                embedData: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case DOMO_REPORT_SUCCESS:
            newState = {
                ...state,
                loading: false,
                embedData: action.embedData
            };

            return isEqual(state, newState) ? state : newState;

        case DOMO_REPORT_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false
            };

            return isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getDomoReportEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'domoReport')
);

export const getDomoReportIsLoading = createSelector(
    getDomoReportEntity,
    (entity) => get(entity, 'loading')
);

export const getDomoReportError = createSelector(
    getDomoReportEntity,
    (entity) => get(entity, 'error')
);

export const getDomoReportErrorMessage = createSelector(
    getDomoReportError,
    (error) => get(error, 'message')
);

export const getDomoEmbedData = createSelector(
    getDomoReportEntity,
    (entity) => get(entity, 'embedData')
);
